import {IRunFile} from '../../incase-domain/proptypes/runfile';
import {
    IRemoveCurrentSlideDrawingAction,
    IResetRunfile,
    ISavePresentationRunFileActionType,
    IUpdatePresentationRunFileAction,
    REMOVE_CURRENT_SLIDE_DRAWING,
    RESET_RUNFILE,
    SAVE_PRESENTATION_RUN_FILE,
    UPDATE_PRESENTATION_RUN_FILE,
} from './types/runfile.actions.types';

export const savePresentationRunFileAction = (runFile: IRunFile): ISavePresentationRunFileActionType => ({
    type: SAVE_PRESENTATION_RUN_FILE,
    runFile,
});

export const removeCurrentSlideDrawingAction = (): IRemoveCurrentSlideDrawingAction => ({
    type: REMOVE_CURRENT_SLIDE_DRAWING,
});

export const updatePresentationRunFileAction = (runFile: IRunFile): IUpdatePresentationRunFileAction => ({
    type: UPDATE_PRESENTATION_RUN_FILE,
    runFile,
});

export const resetRunfileAction = (): IResetRunfile => ({
    type: RESET_RUNFILE,
});
